<template>
    <v-card style="height: 30px; display: flex; flex-direction: row; align-items: center;">
        <span class="px-2">Accommodation: {{this.hspt.huis_code}} </span>
        <span class="px-2">Status: {{this.hspt.stat_code}} </span>
        <span class="px-10">Arrival: {{this.hspt.hspt_aank_van_dat}} - {{this.hspt.hspt_aank_tm_dat}} </span>
        <v-btn small plain v-on:click="updateData"><span v-if="weekprices===true"><v-icon medium class="mr-2">mdi-eye-off-outline</v-icon></span>
        <span v-else><v-icon medium class="mr-2">mdi-eye-outline</v-icon></span>{{ this.title }}</v-btn>
        <span v-if="hspt.hasPriorityPrice">
          <v-icon color="red" class="ml-5">mdi-alert-circle-outline</v-icon><span class="ml-1" style="color: red; font-weight: 600;">Priority prices</span>
        </span>
    </v-card>    
</template>

<script>
  export default {
    props: {
      hspt: Object,
      weekprices: Boolean,
    },
    methods:{
      updateData(){
        console.log('hspt header on click', !this.weekprices);
        this.$emit('updateData', !this.weekprices);
      },    
    },
    computed:{
      title(){
        return this.weekprices===true ? 'hide weekprices' : 'show weekprices' ;
      }
    }
  }
</script>

<style scoped>

</style>